/**
 * App Content Component Exports
 *
 * @since 1.0.0
 */

export { AppContent } from './component';
